import type { TerminalBalanceWithdrawal } from '@/generated/graphql';

import { IAdmin, mapGQLAdmin } from './admin';

export interface ITerminalBalanceWithdrawal {
  id: string;
  amount: number;
  createdAt: string;
  updatedAt: string;

  admin: IAdmin;
}

export interface ITerminalBalanceWithdrawalTable {
  id: string;
  amount: number;
  createdAt: string;
  username: string;
}

export interface ITerminalBalanceWithdrawalQueryVariable {
  first: number;
  after?: string;
  before?: string;
}

export function mapGQLTerminalBalanceWithdrawal(
  gql_terminalBalanceWithdrawal?: TerminalBalanceWithdrawal | null,
): ITerminalBalanceWithdrawal {
  return {
    id: gql_terminalBalanceWithdrawal?.id ?? '',
    amount: gql_terminalBalanceWithdrawal ? gql_terminalBalanceWithdrawal.amount ?? 0 : 0,

    updatedAt: gql_terminalBalanceWithdrawal
      ? gql_terminalBalanceWithdrawal.updatedAt ?? new Date().toISOString()
      : new Date().toISOString(),
    admin: mapGQLAdmin(gql_terminalBalanceWithdrawal?.admin),
    createdAt: gql_terminalBalanceWithdrawal
      ? new Date(gql_terminalBalanceWithdrawal.createdAt).toLocaleString('en-US', {
          timeZone: 'Asia/Manila',
          month: '2-digit',
          day: '2-digit',
          year: 'numeric',
          hour12: true,
          minute: '2-digit',
          hour: '2-digit',
        }) ?? ''
      : '',
  };
}
